/**
 * @fileoverview POST handler for the "/engagement/segments/:segment_id/facebook_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsSegmentIdFacebookExportCacheKeys } from "./constants";
import type {
  PostEngagementSegmentsSegmentIdFacebookExportProps,
  EngagementSegmentsFacebookExportResult,
} from "./types";

export const postEngagementSegmentsFacebookExport = reactQueryMutationAdapter(
  engagementSegmentsSegmentIdFacebookExportCacheKeys,
  (props: PostEngagementSegmentsSegmentIdFacebookExportProps): Promise<EngagementSegmentsFacebookExportResult> => {
    return fetch(`/engagement/segments/${props.segment_id}/facebook_export`, "POST", props);
  }
);
